import React, { useState } from 'react'; // You forgot to import useState!
import Header from './Header';
import Navbar from './Navbar';
import Footer from './Footers';
import './Login.css';

const Login = () => {
    const [loginData, setLoginData] = useState({ username: '', password: '' });
    const [registerData, setRegisterData] = useState({ username: '', email: '', password: '' });

    const handleLogin = (e) => {
        e.preventDefault();
        console.log("Logging in:", loginData);
    };

    const handleRegister = (e) => {
        e.preventDefault();
        console.log("Registering:", registerData);
    };

    return (
        <div>
            <Header />
            <Navbar />

            <div className="auth-container">
                <h2>MY ACCOUNT</h2>
                <div className="form-wrapper">
                    {/* LOGIN FORM */}
                    <form className="form-box" onSubmit={handleLogin}>
                        <h3>LOGIN</h3>
                        <input
                            type="text"
                            placeholder="Username or email address"
                            value={loginData.username}
                            onChange={(e) => setLoginData({ ...loginData, username: e.target.value })}
                            required
                        />
                        <input
                            type="password"
                            placeholder="Password"
                            value={loginData.password}
                            onChange={(e) => setLoginData({ ...loginData, password: e.target.value })}
                            required
                        />
                        <div className="remember-forgot">
                            <label>
                                <input type="checkbox" /> Remember me
                            </label>
                        </div>
                        <button type="submit" className="btn">LOG IN</button>
                        <a href="/" className="forgot-link">Lost your password?</a>
                    </form>

                    {/* REGISTER FORM */}
                    <form className="form-box" onSubmit={handleRegister}>
                        <h3>REGISTER</h3>
                        <input
                            type="text"
                            placeholder="Username"
                            value={registerData.username}
                            onChange={(e) => setRegisterData({ ...registerData, username: e.target.value })}
                            required
                        />
                        <input
                            type="email"
                            placeholder="Email address"
                            value={registerData.email}
                            onChange={(e) => setRegisterData({ ...registerData, email: e.target.value })}
                            required
                        />
                        <input
                            type="password"
                            placeholder="Password"
                            value={registerData.password}
                            onChange={(e) => setRegisterData({ ...registerData, password: e.target.value })}
                            required
                        />
                        <p className="privacy-text">
                            Your personal data will be used to support your experience throughout this website,
                            to manage access to your account, and for other purposes described in our <a href="/">privacy policy</a>.
                        </p>
                        <button type="submit" className="btn">REGISTER</button>
                    </form>
                </div>
            </div>

            <Footer />
        </div>
    );
};

export default Login;
